module.exports = __webpack_public_path__ + "static/img/cliente-2.09de6db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/cliente-2.png
// module id = +q5D
// module chunks = 0